// extracted by mini-css-extract-plugin
export default {"Description":"Description_Description__aX6dr","container":"Description_container__yZCnQ","content":"Description_content__XRQOF","image":"Description_image__9lO4r"};